<div
  class="table-wrapper bg-white border rounded-lg w-full max-h-full overflow-auto relative border-outline-variant"
  data-testid="ai-blueprint-skeleton">
  @if (showHeader) {
    <div class="flex bg-surface-container-lowest border-b border-outline-variant">
      <div class="flex-1 min-w-0 px-4 py-[18px]">
        <app-skeleton width="3rem" height="0.875rem"></app-skeleton>
      </div>
      <div class="w-[120px] shrink-0 px-4 py-[18px]">
        <app-skeleton width="3.5rem" height="0.875rem"></app-skeleton>
      </div>
      <div class="w-[120px] shrink-0 px-4 py-[18px]">
        <app-skeleton width="3.5rem" height="0.875rem"></app-skeleton>
      </div>
      <div class="w-[80px] shrink-0 px-4 py-[18px]">
        <app-skeleton width="3rem" height="0.875rem"></app-skeleton>
      </div>
    </div>
  }
  @for (i of placeholders; track i) {
    <div class="flex bg-white border-b border-outline-variant last:border-b-0">
      <div class="flex-1 min-w-0 px-4 py-[18px]">
        <app-skeleton width="55%" height="1rem"></app-skeleton>
      </div>
      <div class="w-[120px] shrink-0 px-4 py-[18px]">
        <app-skeleton width="4.5rem" height="0.875rem"></app-skeleton>
      </div>
      <div class="w-[120px] shrink-0 px-4 py-[18px]">
        <app-skeleton width="4.5rem" height="0.875rem"></app-skeleton>
      </div>
      <div class="w-[80px] shrink-0 px-4 py-[18px] flex items-center">
        <app-skeleton width="2.25rem" height="1.25rem" rounded="full"></app-skeleton>
      </div>
    </div>
  }
</div>
